import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/styles/App.css';

import React, { useState,useEffect } from 'react';

import {
  BrowserRouter as Router,
  Route,
  Routes,
} from 'react-router-dom';

import FamilyTree from './components/App/FamilyTree';
import InviteAction from './components/App/InviteAction';
import AddMember from './components/Tree/AddMember';
import EditMember from './components/Tree/EditMember';

import WebFamilyTree from './components/Tree/WebFamilyTree';
import WebFamilyTreeShare from './components/Tree/WebFamilyTreeShare';
import BubbleMap from './components/App/BubbleMap';
import BiologicalTree from './components/App/BiologicalTree';
import FriendsId from './Pages/FriendsId/FriendsId';
import Home from './Pages/Home/Home';
import Landing from './Pages/Landing/Landing';
import ViewTerm from './Pages/Landing/ViewTerm';
import ViewPrivacy from './Pages/Landing/ViewPrivacy';
import ViewHelp from './Pages/Landing/ViewHelp';
import ViewBlogs from './Pages/Landing/ViewBlogs';


import MemberAdd from './Pages/MemberAdd/MemberAdd';
import Notification from './Pages/Notification/Notification';
import Profile from './Pages/Profile/Profile';
import Login from './Pages/RegisterPage/Login';
import SignUp from './Pages/RegisterPage/SignUp';
import Logout from './Pages/RegisterPage/Logout';
import axiosInstance from './axios';
import { getAuth, getRedirectResult, GoogleAuthProvider } from "firebase/auth";
import { API_KEY, API_BASE_URL } from './constants';
import axios from 'axios';

function App() {
  const [friendProfile, setFriendsProfile] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
      const auth = getAuth();
      if(localStorage.getItem('googleLogin')){
        setLoading(false);
      }
    getRedirectResult(auth)
      .then((result) => {
        // This gives you a Google Access Token. You can use it to access Google APIs.
        if(result){
            const credential = GoogleAuthProvider.credentialFromResult(result);
            const token = credential.accessToken;

            // The signed-in user info.
            const user = result.user;
            const otpSentDetails = JSON.parse(localStorage.getItem('OtpSentDetails')) || {}
            const response = axiosInstance.post(`${API_BASE_URL}login-using-email`,{
              email: user.email,
              mobile:otpSentDetails.OtpSentToMobile
          }, {
              headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json',
                  'X-Api-Key': API_KEY,
              },
          }).then(response=>response.data).then(responseData=>{
              console.log(responseData)

              if(responseData && responseData.data)
              { 
                if(responseData.data.is_verified){
                  const token_response=result._tokenResponse
                  let first_name=token_response.firstName;
                  let last_name=token_response.lastName;
                  let email=token_response.email;
                  email=user.email;
                  localStorage.setItem('userData', JSON.stringify(responseData.data));
                  localStorage.setItem('accessToken',responseData.data.access);
                  localStorage.setItem('refreshToken',responseData.data.refresh);
                  // Accessing member_id from the response data
                  const member_id = responseData.data.user_profile.member_id;
                  const baseUrl = window.location.origin;
                  const url = `${baseUrl}/webtree/`+member_id+"?first_name="+first_name+"&last_name="+last_name+"&email="+email;
                  localStorage.removeItem("googleLogin")
                  setLoading(false);
                  window.location.href=url
                }
                else{
                  console.log(responseData.data.message);
                  setLoading(false);
                }
              }
              else{
                alert("some error occured!")
                setLoading(false);
              }
              localStorage.removeItem("googleLogin")
          });
        }

      }).catch((error) => {
        console.log(error);
      });});

      
      useEffect(() => {
        // Define the global function to receive messages from Flutter
       

        window.startBlinkingForMembers = function (input_message) {
          const fixedInput = input_message
        .replace(/([{,]\s*)([a-zA-Z0-9_]+)(\s*:)/g, '$1"$2"$3')
        .replace(/:\s*([a-zA-Z0-9\-]+)([,}])/g, ': "$1"$2')
        .replace(/:\s*([a-zA-Z0-9\s]+)([,}])/g, ': "$1"$2');
          let  memberIds;
          try {
            const parsedObject = JSON.parse(fixedInput);
            
            // Extract the member_id from the data array
             memberIds = parsedObject.data.map(item => item.member_id);
            
        } catch (error) {
            // Handle the error, for example log an error message
            console.log("Invalid JSON format:", error.message);
        }
          memberIds.forEach(memberId => {
            // Select the card element that matches the specific data-id
            const cardElement = document.querySelector(`.card[data-id="${memberId}"]`);
            // If the card element is found, add the blinking class to its outline
            if (cardElement) {
            const outlineElement = cardElement.querySelector('.card-outline'); // Base outline element
            if (outlineElement) {
              outlineElement.classList.add('card-blink-outline'); // Add blinking class
          
              // Stop blinking after 10 seconds (optional)
              setTimeout(() => {
              outlineElement.classList.remove('card-blink-outline');
              }, 10000); // 10 seconds
            }
            }
          });
        };
    
        // Cleanup function to remove the global function when the component unmounts
        return () => {
          delete window.startBlinkingForMembers;
        };
      }, []); // Empty dependency array here too, so this runs only once after initial render
    
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route index element={<Landing />} />
          <Route path='' element={<Landing />} />
          <Route path="" element={<Landing />} />
          <Route path="/tree/:userId/:accessToken/:refreshToken/:refreshTree?" element={<FamilyTree />} />
          <Route path="/webtree/:userId" element={<WebFamilyTree />} />
          <Route path="/sharetree/:userId" element={<WebFamilyTreeShare />} />
          <Route path="/mindmap/:memberId" element={<BubbleMap />} />
          <Route path="/biologicalTree/:memberId" element={<BiologicalTree />} />
          <Route path="/invite" element={<InviteAction />} />
          <Route path='/story' element={<Home setFriendsProfile={setFriendsProfile} />} />
          <Route path='/story:userId' element={<Home setFriendsProfile={setFriendsProfile} />} />
          <Route path='/profile' element={<Profile />} />
          <Route path='/profile/:userId' element={<Profile />} />
          <Route path='/friendsId' element={<FriendsId friendProfile={friendProfile} />} />
          <Route path='/notification' element={<Notification />} />
          <Route path='/login' element={<Login loading={loading} />} />
          <Route path='/signup' element={<SignUp />} />
          <Route path='/add-member' element={<MemberAdd />} />
          <Route path='/add-member/:userId' element={<MemberAdd />} />
          <Route path='/member-add' element={<AddMember />} />
          <Route path='/:userId/member-add' element={<AddMember />} />
          <Route path='/:userId/member-add/:name' element={<AddMember />} />
          <Route path="/:userId/add-member/:name" element={<AddMember />} />
          <Route path="/:userId/edit-member/" element={<EditMember />} />
          <Route path="/terms/" element={<ViewTerm />} />
          <Route path="/privacy/" element={<ViewPrivacy />} />
          <Route path="/blogs" element={<ViewBlogs />} />
          <Route path="/help" element={<ViewHelp />} />
          <Route path="/logout" element={<Logout />} />


          <Route path='/home' element={<Home setFriendsProfile={setFriendsProfile} />} />
          <Route path='/home/:userId' element={<Home setFriendsProfile={setFriendsProfile} />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
